export default "__VITE_ASSET__DWaUz68s__"